<template>
  <div class="container-fluid">
    <div class="row">
      <!-- Unified Card for User Info and Media Gallery -->
      <div class="col-md-8">
        <div class="card p-3">
          <h4>User Details</h4>
          <form novalidate @submit.prevent="updateCandidate">

            <div class="row">

            <!-- User Details Section -->
            <div class="form-group mb-3 col-md-6">
              <label for="name" class="form-control-label">
                {{ $t('name') }} <span class="text-danger">*</span>
              </label>
              <soft-input v-model="newCandidate.name" id="name" type="text" placeholder="Enter Full Name" icon="mdi-account" />
              <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
            </div>

            <!-- EMAIL ADDRESS FIELD -->
            <div class="form-group mb-3 col-md-6">
              <label for="email" class="form-control-label">
                Email Address <span class="text-danger">*</span>
              </label>
              <soft-input v-model="newCandidate.email" id="email" type="email" placeholder="Enter Email" icon="mdi-email" />
              <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
            </div>

            <div class="form-group mb-3 col-md-6">
              <label for="phone_no" class="form-control-label">
                {{ $t('phone_number') }} <span class="text-danger">*</span>
              </label>
              <soft-input v-model="newCandidate.phone" id="phone" type="text" :placeholder="$t('phone_number_placeholder')" icon="mdi-phone" @input="prependCountryCode" />
              <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
            </div>

            <!-- ROLE FIELD -->
            <div class="form-group mb-3 col-md-6">
              <label for="role" class="form-control-label">
                Role <span class="text-danger">*</span>
              </label>
              <select v-model="newCandidate.role_id" id="role" class="form-control" @change="onRoleChange" required>
                <option value="" disabled>Select Role</option>
                <option v-for="role in filteredRoles" :key="role.id !== undefined ? role.id : role.role_id" :value="role.id !== undefined ? role.id : role.role_id">
                  {{ role.name || role.role_name }}
                </option>
              </select>
              <small v-if="errors.role_id" class="text-danger">{{ errors.role_id }}</small>
            </div>

            <!-- STATUS FIELD -->
            <div class="form-group mb-3 col-md-6">
              <label for="status" class="form-control-label">
                {{ $t("status") || 'Status' }} <span class="text-danger">*</span>
              </label>
              <select v-model="newCandidate.status" id="status" class="form-control" required>
                <option value="1">Active</option>
                <option value="0">InActive</option>
              </select>
            </div>

            <!-- GENDER FIELD: Displayed conditionally when role is Doctor -->
            <div v-if="showGenderField" class="form-group mb-3 col-md-6">
              <label for="gender" class="form-control-label">
                Gender
              </label>
              <select v-model="newCandidate.gender" id="gender" class="form-control">
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div v-for="(deviceSelection, index) in selectedDevices" :key="index" class="row">
  <div class="form-group mb-3 col-md-6">
    <label>Devices List</label>
    <select v-model="deviceSelection.deviceId" class="form-control" disabled>
      <option value="" disabled>Select a Device</option>
      <option v-for="device in devices" :key="device.id" :value="device.id">
        {{ device.device_name }}
      </option>
    </select>
  </div>

  <div class="form-group mb-3 col-md-6">
    <label>Play List</label>
    <select v-model="deviceSelection.playlistId" class="form-control">
      <option value="" disabled>Select a Playlist</option>
      <option v-for="playlist in playlists" :key="playlist.id" :value="playlist.id">
        {{ playlist.playlist_name }}
      </option>
    </select>
  </div>
</div>


            </div>

            <!-- Common Submit Button and Back Button -->
            <div class="text-center mt-4 d-flex justify-content-center align-items-center gap-2">
              <button 
                type="button" 
                class="btn bg-gradient-secondary my-4 me-2 px-4" 
                @click="goBack"
              >
                Back
              </button>
              <button 
                type="submit" 
                class="btn bg-gradient-dark my-4 px-4"
                @click="updateCandidate"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftInput from "@/components/SoftInput.vue";
import resourcePhotoUrl from "@/assets/img/resource.png";
import CandidateDataService from "../../services/CandidateDataService.js";
import DeviceDataService from "../../services/DeviceDataService.js";
//import MediaDataService from "../../services/MediaDataService.js";
import PlaylistMasterDataService from "../../services/PlaylistMasterDataService.js";
import RolesDataService from "../../services/RolesDataService.js";
import { handleApiErrors } from '@/utils/errorHandler';
import Swal from 'sweetalert2';
import axios from 'axios';

export default {
  name: "EditCandidate",
  components: {
    SoftInput,
  },
  data() {
    return {
      candidate_id: null, // Added candidate_id initialization
      devices: [],
      playlists: [],
      selectedDevices: [],
      selectedDevice: null,
      selectedDeviceId: "",
      selectedPlaylistId: "",
      mediaOptions: [],
      mediaList: [],
      resourcePhotoUrl,
      roles: [],
      installationTypes: [],
      mediRoles: [],
      newCandidate: {
        id: "",
        name: "",
        email: "", // Added email to object
        phone: "",
        installation_type_id: "",
        role_id: "",
        gender: "",
        status: "1",
        type: "",
        device_id: "",
        playlist_master_id: "",
        devices: [],
      },
      errors: {
        name: "",
        email: "", // Added email to errors
        phone: "",
        installation_type_id: "",
        role_id: "",
        media: [],
        device: "",
        playlist_name: "",
      },
    };
  },
  computed: {
    isDoctorRole() {
      if (!this.newCandidate.role_id) return false;
      const selectedRoleObj = (this.roles || []).find(r => 
        String(r.id !== undefined ? r.id : r.role_id) === String(this.newCandidate.role_id)
      ) || (this.filteredRoles || []).find(r => 
        String(r.id !== undefined ? r.id : r.role_id) === String(this.newCandidate.role_id)
      );
      const roleName = selectedRoleObj ? (selectedRoleObj.name || selectedRoleObj.role_name || '') : '';
      return String(roleName).toLowerCase().includes('doctor');
    },
    showGenderField() {
      return this.isDoctorRole;
    },
    isMedicalType() {
      const selected = (this.installationTypes || []).find(t => t.id == this.newCandidate.installation_type_id);
      return selected && selected.name && selected.name.toLowerCase().includes('medical');
    },
    filteredInstallationTypes() {
      const userInstType = (localStorage.getItem('installationType') || '').toLowerCase();
      const userInstId = localStorage.getItem('installation_type_id');

      if (userInstType === 'medical' || userInstId == '2' || userInstId == '5') {
        return (this.installationTypes || []).filter(t => t.id == 2 || t.id == 5 || String(t.name).toLowerCase().includes('medical'));
      } else if (userInstType === 'media' || userInstId == '1' || userInstId == '6') {
        return (this.installationTypes || []).filter(t => t.id == 1 || t.id == 6 || String(t.name).toLowerCase().includes('media'));
      }
      return this.installationTypes || [];
    },
    // UPDATED: Now returns all roles without restricting to medical-only keywords
    filteredRoles() {
      const allRoleList = [...(this.roles || [])];

      if (Array.isArray(this.mediRoles)) {
        this.mediRoles.forEach(mr => {
          const exists = allRoleList.some(r => 
            (r.id && mr.id && (r.id == mr.id || r.role_id == mr.id || r.id == mr.role_id)) || 
            (r.name && mr.name && r.name.toLowerCase() === mr.name.toLowerCase())
          );
          if (!exists) allRoleList.push(mr);
        });
      }

      return allRoleList;
    },
  },
  watch: {
    roles() {
      this.resolveRoleId();
    },
    mediRoles() {
      this.resolveRoleId();
    },
    'newCandidate.role_id'() {
      this.resolveRoleId();
    }
  },
  created() {
    this.candidate_id = this.$route.params.id;
    if (this.candidate_id && this.candidate_id !== '[object Object]' && this.candidate_id !== 'undefined') {
      this.getCandidateDetails(this.candidate_id);
      this.getAllUserDevices();
      this.getAllUsersPlaylist();
    }
    this.fetchInstallationTypes();
    this.fetchRolesData();
    this.fetchMediRoles();
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/users');
      }
    },
    getAuthToken() {
      return localStorage.getItem('token') || 
             localStorage.getItem('auth_token') || 
             localStorage.getItem('admin_token');
    },
    async fetchInstallationTypes() {
      try {
        const token = this.getAuthToken();
        const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
        const response = await axios.get(`${apiBaseUrl}/v1/admin/installation-types`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        this.installationTypes = response.data.data || response.data || [];
      } catch (e) {
        console.error("Error fetching types", e);
      }
    },
    async fetchRolesData() {
      try {
        const response = await RolesDataService.getAll();
        this.roles = response.data.data || response.data || [];
        this.resolveRoleId();
      } catch (e) {
        console.error("Error fetching roles", e);
      }
    },
    async fetchMediRoles() {
      try {
        const token = this.getAuthToken();
        const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
        const response = await axios.get(`${apiBaseUrl}/v1/admin/roles/list`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        this.mediRoles = response.data.data || response.data || [];
        this.resolveRoleId();
      } catch (e) {
        console.error("Error fetching medical roles", e);
      }
    },
    resolveRoleId() {
      if (!this.newCandidate.role_id && this.newCandidate.role) {
        this.newCandidate.role_id = this.newCandidate.role;
      }
      if (this.newCandidate.role_id) {
        const targetVal = String(this.newCandidate.role_id).toLowerCase().trim().replace(/\s+/g, '');
        const allRoles = this.filteredRoles || [];
        const match = allRoles.find(r => {
          if (!r) return false;
          const rId = String(r.id !== undefined ? r.id : (r.role_id !== undefined ? r.role_id : '')).toLowerCase().trim();
          const rName = String(r.name || r.role_name || '').toLowerCase().trim().replace(/\s+/g, '');
          const rSlug = String(r.slug || r.role_slug || '').toLowerCase().trim().replace(/\s+/g, '');
          return rId === targetVal || rName === targetVal || rSlug === targetVal;
        });

        if (match) {
          const matchedId = match.id !== undefined ? match.id : match.role_id;
          this.newCandidate.role_id = matchedId;
        }
      }
    },
    onRoleChange() {
      const selectedRole = (this.roles || []).find(r => (r.id !== undefined ? r.id : r.role_id) == this.newCandidate.role_id) ||
                           (this.mediRoles || []).find(r => (r.role_id || r.id) == this.newCandidate.role_id);
      if (selectedRole) {
        const derivedInst = selectedRole.installation_type_id || selectedRole.installation_id || selectedRole.type_id;
        if (derivedInst) {
          this.newCandidate.installation_type_id = derivedInst;
        }
      }
    },
    clearErrors() {
      this.errors = {
        name: "",
        email: "", // Clear email error
        phone: "",
        installation_type_id: "",
        role_id: "",
        media: [],
      }
    },
    populateFromCandidateObj(canData) {
      const q = this.$route.query || {};
      if (!canData) return;

      const emailVal = canData.email || 
                       canData.email_address || 
                       canData.admin_email || 
                       canData.user_email || 
                       canData.mail || 
                       q.email || 
                       "";

      const nameVal = canData.name || 
                      canData.userName || 
                      canData.user_name || 
                      canData.full_name || 
                      q.name || 
                      "";

      const phoneVal = canData.phone || 
                       canData.phone_no || 
                       canData.phone_number || 
                       canData.mobile || 
                       q.phone || 
                       "";

      let roleVal = canData.role_id || 
                    canData.roleId || 
                    (canData.role && typeof canData.role === 'object' ? (canData.role.id || canData.role.role_id) : '') || 
                    canData.role_name || 
                    (typeof canData.role === 'string' ? canData.role : '') || 
                    q.role_id || 
                    "";

      const instVal = canData.installation_type_id || 
                      canData.installation_id || 
                      canData.type || 
                      q.installation_type_id || 
                      "";

      this.newCandidate = {
        id: canData.id || this.candidate_id,
        name: nameVal,
        email: emailVal,
        phone: phoneVal,
        installation_type_id: instVal,
        role_id: roleVal,
        gender: canData.gender || q.gender || "",
        status: canData.status !== undefined && canData.status !== null ? String(canData.status) : (q.status !== undefined ? String(q.status) : "1"),
        type: canData.type || instVal || "",
        devices: canData.devices || [],
      };

      this.resolveRoleId();

      if (Array.isArray(canData.devices)) {
        this.selectedDevices = canData.devices.map(device => ({
          deviceId: device.id,
          playlistId: device.playlist_master_id,
        }));
      }
    },
    getCandidateDetails() {
      const q = this.$route.query || {};

      // 1. Immediately pre-populate from route query if available for instant UI response
      if (q.name || q.email || q.phone) {
        this.populateFromCandidateObj(q);
      }

      // 2. Call getAllUser() FIRST (GET /v1/admin/user) to fetch tenant user details cleanly
      CandidateDataService.getAllUser()
        .then(res => {
          const listData = res.data;
          const users = Array.isArray(listData) 
            ? listData 
            : (listData && Array.isArray(listData.data) ? listData.data : (listData && Array.isArray(listData.users) ? listData.users : (listData && Array.isArray(listData.candidates) ? listData.candidates : [])));

          const matchedUser = users.find(u => u.id == this.candidate_id);
          if (matchedUser) {
            console.log("Found user details from tenant users list:", matchedUser);
            this.populateFromCandidateObj(matchedUser);
          } else if (!q.name && !q.email && !q.phone) {
            // 3. Fallback to central GET /user/edit/:id ONLY if user is not in tenant list
            this.fetchFromCentralAdmin(q);
          }
        })
        .catch(err => {
          console.log("Error fetching tenant users list:", err);
          if (!q.name && !q.email && !q.phone) {
            this.fetchFromCentralAdmin(q);
          }
        });
    },
    fetchFromCentralAdmin(q) {
      CandidateDataService.getAdmin(this.candidate_id)
        .then((response) => {
          const raw = response.data || {};
          const canData = (raw.user && typeof raw.user === 'object') 
            ? raw.user 
            : ((raw.data && typeof raw.data === 'object') ? raw.data : (raw.candidate || raw.result || raw));

          if (canData && (canData.name || canData.email || canData.phone)) {
            this.populateFromCandidateObj(canData);
          } else if (q.name || q.email || q.phone) {
            this.populateFromCandidateObj(q);
          }
        })
        .catch((err) => {
          console.log("Central getAdmin notice:", err.response?.data || err);
          if (q.name || q.email || q.phone) {
            this.populateFromCandidateObj(q);
          }
        });
    },
    getAllUserDevices() {
      DeviceDataService.getAllUserDevices(this.candidate_id)
        .then((response) => {
          this.devices = response.data;
          console.log(this.devices);
        })
        .catch((e) => console.log(e));
    },
    async getAllUsersPlaylist() {
      const token = this.getAuthToken();
      const baseUrl = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '');
      try {
        const response = await axios.get(`${baseUrl}/v1/admin/playlists?_t=${Date.now()}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const resData = response.data?.data || response.data || [];
        if (Array.isArray(resData) && resData.length > 0) {
          this.playlists = resData;
        } else {
          const userPlaylistsRes = await PlaylistMasterDataService.getAll(this.candidate_id);
          this.playlists = userPlaylistsRes.data?.data || userPlaylistsRes.data || [];
        }
      } catch (e) {
        console.log("Error fetching playlists, attempting fallback:", e);
        PlaylistMasterDataService.getAll(this.candidate_id)
          .then(res => { this.playlists = res.data?.data || res.data || []; })
          .catch(err => console.log(err));
      }
    },
    prependCountryCode() {
      if (this.newCandidate.phone && !this.newCandidate.phone.startsWith("+91")) {
        this.newCandidate.phone = "+91" + this.newCandidate.phone;
      }
    },
    validateForm() {
      this.clearErrors();
      let valid = true;

      if (!this.newCandidate.name) {
        this.errors.name = "Name is required";
        valid = false;
      }

      // Added Email Validation
      if (!this.newCandidate.email) {
        this.errors.email = "Email is required";
        valid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newCandidate.email)) {
        this.errors.email = "Invalid email format";
        valid = false;
      }

      if (!this.newCandidate.phone) {
        this.errors.phone = "Phone number is required";
        valid = false;
      }

      if (!this.newCandidate.role_id) {
        this.errors.role_id = "Role is required";
        valid = false;
      }

      return valid;
    },

    async updateCandidate() {
      console.log("Submit clicked, candidate:", this.newCandidate);
      if (!this.validateForm()) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please check the required fields highlighted in red.',
        });
        return;
      }

      const isMed = this.isMedicalType;
      const selectedRole = (this.roles || []).find(role => (role.id !== undefined ? role.id : role.role_id) == this.newCandidate.role_id) ||
                           (this.mediRoles || []).find(role => (role.role_id || role.id) == this.newCandidate.role_id);

      const roleName = selectedRole?.name || selectedRole?.role_name || selectedRole?.slug || "";
      const roleInstType = selectedRole?.installation_type_id || selectedRole?.installation_id || selectedRole?.type_id || this.newCandidate.installation_type_id;
      const parsedRoleId = !isNaN(this.newCandidate.role_id) ? Number(this.newCandidate.role_id) : this.newCandidate.role_id;
      const targetId = !isNaN(this.candidate_id) ? Number(this.candidate_id) : this.candidate_id;

      const updatedCandidate = {
        id: targetId,
        user_id: targetId,
        candidate_id: targetId,
        name: this.newCandidate.name,
        user_name: this.newCandidate.name,
        full_name: this.newCandidate.name,
        email: this.newCandidate.email,
        email_address: this.newCandidate.email,
        phone: this.newCandidate.phone,
        phone_no: this.newCandidate.phone,
        phone_number: this.newCandidate.phone,
        gender: this.showGenderField ? (this.newCandidate.gender || null) : null,
        status: Number(this.newCandidate.status),
        role_id: parsedRoleId,
        role: roleName || String(parsedRoleId),
        role_name: roleName,
        role_slug: selectedRole?.slug || roleName,
        installation_type_id: roleInstType,
        type: selectedRole?.type || roleInstType || (isMed ? 2 : this.newCandidate.installation_type_id),
        devices: this.selectedDevices.map(device => ({
          id: device.deviceId,
          playlist_master_id: device.playlistId,
        })),
      };

      const token = this.getAuthToken();
      let baseUrl = process.env.VUE_APP_API_BASE_URL || '';
      baseUrl = baseUrl.replace(/\/+$/, '');

      try {
        const headers = { Authorization: `Bearer ${token}` };
        
        let response;
        try {
          response = await axios.post(`${baseUrl}/v1/admin/user/update/${this.candidate_id}`, updatedCandidate, { headers });
        } catch (postErr1) {
          try {
            response = await axios.post(`${baseUrl}/v1/admin/mediauser/update/${this.candidate_id}`, updatedCandidate, { headers });
          } catch (postErr2) {
            try {
              response = await axios.post(`${baseUrl}/v1/admin/user/update`, updatedCandidate, { headers });
            } catch (postErr3) {
              response = await axios.put(`${baseUrl}/v1/admin/user/update/${this.candidate_id}`, updatedCandidate, { headers });
            }
          }
        }

        console.log("Candidate updated successfully:", response.data);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Details Updated successfully!',
          confirmButtonText: 'OK'
        }).then(() => {
          this.$router.push('/users');
        });

      } catch (error) {
        console.error("Error updating candidate:", error);
        const errorMessages = handleApiErrors(error);
        if (errorMessages) {
          this.errors = errorMessages;
        }
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.response?.data?.msg || 'Failed to update user details.'
        });
      }
    },
  },
};
</script>


<style scoped>
.container-fluid {
  padding: 0;
  margin-top: 0px;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  width: 100%;
}

.card-body {
  padding: 10px; /* Reduced padding inside the card */
}

.form-group {
  margin-bottom: 0.75rem; /* Smaller margin for form fields */
}

.text-danger {
  font-size: 12px;
}

.media-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px; /* Space between cards */
}

.media-card {
  flex: 1 1 100%; /* Full width on small screens */
  margin-bottom: 15px; /* Adjusted space for rows */
  padding: 10px;
  position: relative;
  max-width: 100%; /* Ensures full width */
}

/* Medium screens and up */
@media (min-width: 768px) {
  .media-card {
    flex: 1 1 calc(50% - 15px); /* Two cards per row */
    max-width: calc(50% - 15px);
  }
}

/* Large screens and up */
@media (min-width: 992px) {
  .media-card {
    flex: 1 1 calc(25% - 15px); /* 4 cards per row */
    max-width: calc(25% - 15px);
  }
}

.media-image,
.media-video {
  width: 100%;
  height: 100px; /* Reduced height for media previews */
  object-fit: contain;
}

button.btn {
  font-size: 14px;
}

.remove-media-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  border: none;
  color: #ff0000;
  font-size: 16px; /* Smaller font size */
  padding: 10px; /* Reduced padding */
  cursor: pointer;
}

.remove-media-btn .mdi-close {
  font-size: 18px; /* Adjust the icon size */
}

.text-center {
  margin-top: 20px;
}

/* Smaller text fields and dropdowns */
select.form-control,
input.form-control {
  font-size: 14px;
  padding: 8px;
}

label.form-control-label {
  font-size: 14px;
}

.small-form-group {
  margin-bottom: 1rem; /* Adjust for small forms */
}
</style>